import React, { useRef } from 'react'
import { WithFeatureDiscoveryProps } from './WithFeatureDiscoveryProps'

const withFeatureDiscovery =
    <T extends object>(
        Component: React.ComponentType<T>
    ): React.FC<T & WithFeatureDiscoveryProps> =>
    // eslint-disable-next-line react/display-name
    ({ featureDiscoveryProps, ...componentProps }: T & WithFeatureDiscoveryProps) => {
        useRef(featureDiscoveryProps)
        return <Component {...(componentProps as T)} />
    }

export default withFeatureDiscovery
